export default __webpack_public_path__ + "static/media/dashboard_check.64d99f40.svg";